// @generated by tools/docgen — do not edit.
// Source: docs/examples/nested_model.md

import React from 'react';
import { NestedModelDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function NestedModelPage() {
  return (
    <ExampleLayout title="Nested model" demo={<NestedModelDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          Demonstrates a nested serializer: the User model has a foreign key to Company, and UserSerializer embeds CompanySerializer. Both name fields stream to the client through a single rx.model declaration.
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-nested-model-backend">
        <ExampleSectionHeading id="examples-nested-model-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="nested_model/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-nested-model-models">
        <ExampleSectionHeading id="examples-nested-model-models">
          Models
        </ExampleSectionHeading>
        <SourceFile path="nested_model/models.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-nested-model-serializers">
        <ExampleSectionHeading id="examples-nested-model-serializers">
          Serializers
        </ExampleSectionHeading>
        <SourceFile path="nested_model/serializers.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-nested-model-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-nested-model-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="nested_model/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default NestedModelPage;
